import { Cookie } from '../../Cookie/Cookie';

export default async function deleteAccessToken(): Promise<any>
{
    sessionStorage.removeItem('accessToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('accessTokenExpirationDate');
    await Cookie.delete('access_token');
}
